import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Container,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Add, Delete, Edit } from '@mui/icons-material';
import PackageForm from './packages_form';
import TabHeaderTypography from '../tab_header';

const ManagePackages = ({ packages, features }) => {
  const [loading, setLoading] = useState(true);
  const [openForm, setOpenForm] = useState(false);
  const [currentPackage, setCurrentPackage] = useState(null);

  //   useEffect(() => {
  //     fetchData();
  //   }, []);

  //   const fetchData = async () => {
  //     try {
  //       setLoading(true);
  //       // Replace with actual API calls
  //       // const packagesResponse = await api.get('/packages');
  //       // const featuresResponse = await api.get('/features');

  //       // Mock data for demonstration
  //       const mockFeatures = [
  //         { id: '1', name: 'Registered Office Address' },
  //         { id: '2', name: 'Digital Incorporation Certificate' },
  //       ];

  //       const mockPackages = [
  //         {
  //           id: 'digital',
  //           name: 'Digital plan',
  //           price: '2.48',
  //           note: '+ £50 Companies House Fee',
  //           features: mockFeatures.slice(0, 1),
  //           displayOrder: 1,
  //           active: true,
  //         },
  //       ];

  //       setFeatures(mockFeatures);
  //       setPackages(dummyPackages);
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this package?')) {
      try {
        // Replace with actual API call
        // await api.delete(`/packages/${id}`);
        //fetchData();
      } catch (error) {
        console.error('Error deleting package:', error);
      }
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
        <TabHeaderTypography title="Manage" highlight="Packages" />
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => {
            setCurrentPackage(null);
            setOpenForm(true);
          }}
        >
          Add Package
        </Button>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Price</TableCell>
              <TableCell>Features</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {packages.map((pkg) => (
              <TableRow key={pkg.id}>
                <TableCell>
                  <Typography fontWeight="medium">{pkg.name}</Typography>
                  {pkg.badge && (
                    <Chip label={pkg.badge} size="small" color="primary" />
                  )}
                </TableCell>
                <TableCell>£{pkg.price}</TableCell>
                <TableCell>{pkg.features.length}</TableCell>
                <TableCell>
                  <Chip
                    label={pkg.active ? 'Active' : 'Inactive'}
                    color={pkg.active ? 'success' : 'error'}
                    size="small"
                  />
                </TableCell>
                <TableCell>
                  <IconButton
                    onClick={() => {
                      setCurrentPackage(pkg);
                      setOpenForm(true);
                    }}
                  >
                    <Edit />
                  </IconButton>
                  <IconButton onClick={() => handleDelete(pkg.id)}>
                    <Delete color="error" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <PackageForm
        open={openForm}
        onClose={() => setOpenForm(false)}
        onSave={() => {
          setOpenForm(false);
          //fetchData();
        }}
        packageData={currentPackage}
        features={features}
      />
    </Container>
  );
};

export default ManagePackages;
